import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";

const LeadsDistribution = ({ leadsStats }) => {
  const distribution = leadsStats?.distribution || {};
  const byList = distribution.byList || [];
  const byType = distribution.byType || [];

  // Calculate totals for percentage calculation
  const totalByList = byList.reduce((sum, item) => sum + (item.count || 0), 0);
  const totalByType = byType.reduce((sum, item) => sum + (item.count || 0), 0);

  // Prepare pie chart data for lists
  const listSeries = byList.map(item => item.count || 0);
  const listChartData = {
    series: listSeries,
    options: {
      chart: {
        type: "donut",
        height: 300,
      },
      labels: byList.map(item => item.listName),
      colors: ["#556ee6", "#34c38f", "#f46a6a", "#f1b44c", "#50a5f1"],
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          // Use pre-calculated total or fallback to opts if available
          if (totalByList > 0 && opts?.seriesIndex !== undefined) {
            const value = listSeries[opts.seriesIndex] || 0;
            const percentage = ((value / totalByList) * 100).toFixed(1);
            return percentage + "%";
          }
          // Fallback to opts if available
          if (opts?.w?.globals?.series && opts.seriesIndex !== undefined) {
            const value = opts.w.globals.series[opts.seriesIndex];
            const total = opts.w.globals.seriesTotals?.reduce((a, b) => a + b, 0) || 0;
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0.0";
            return percentage + "%";
          }
          return val.toFixed(1) + "%";
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            // Use pre-calculated total - val is already the count value
            if (totalByList > 0 && val > 0) {
              const percentage = ((val / totalByList) * 100).toFixed(1);
              return `${val} leads (${percentage}%)`;
            }
            return `${val || 0} leads`;
          },
        },
      },
    },
  };

  // Prepare pie chart data for types
  const typeSeries = byType.map(item => item.count || 0);
  const typeChartData = {
    series: typeSeries,
    options: {
      chart: {
        type: "donut",
        height: 250,
      },
      labels: byType.map(item => item.type || "Sin tipo"),
      colors: ["#556ee6", "#34c38f", "#f46a6a", "#f1b44c"],
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          // Use pre-calculated total or fallback to opts if available
          if (totalByType > 0 && opts?.seriesIndex !== undefined) {
            const value = typeSeries[opts.seriesIndex] || 0;
            const percentage = ((value / totalByType) * 100).toFixed(1);
            return percentage + "%";
          }
          // Fallback to opts if available
          if (opts?.w?.globals?.series && opts.seriesIndex !== undefined) {
            const value = opts.w.globals.series[opts.seriesIndex];
            const total = opts.w.globals.seriesTotals?.reduce((a, b) => a + b, 0) || 0;
            const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : "0.0";
            return percentage + "%";
          }
          return val.toFixed(1) + "%";
        },
      },
      tooltip: {
        y: {
          formatter: function (val) {
            // Use pre-calculated total - val is already the count value
            if (totalByType > 0 && val > 0) {
              const percentage = ((val / totalByType) * 100).toFixed(1);
              return `${val} leads (${percentage}%)`;
            }
            return `${val || 0} leads`;
          },
        },
      },
    },
  };

  return (
    <React.Fragment>
      <Col lg={6}>
        <Card>
          <CardBody>
            <h4 className="card-title mb-3">Distribución de Leads</h4>

            <Row>
              {byList.length > 0 && (
                <Col md={6}>
                  <div className="text-center mb-2">
                    <h6 className="font-size-13 mb-0 text-muted">Por Lista</h6>
                  </div>
                  <div id="list-chart">
                    <ReactApexChart
                      options={listChartData.options}
                      series={listChartData.series}
                      type="donut"
                      height={250}
                    />
                  </div>
                </Col>
              )}

              {byType.length > 0 && (
                <Col md={6}>
                  <div className="text-center mb-2">
                    <h6 className="font-size-13 mb-0 text-muted">Por Tipo</h6>
                  </div>
                  <div id="type-chart">
                    <ReactApexChart
                      options={typeChartData.options}
                      series={typeChartData.series}
                      type="donut"
                      height={250}
                    />
                  </div>
                </Col>
              )}

              {byList.length === 0 && byType.length === 0 && (
                <Col md={12}>
                  <div className="text-center text-muted py-4">
                    No hay datos de distribución disponibles
                  </div>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default LeadsDistribution;

